// actionsReducer.js

import * as types from '../constants/ActionTypes-ticket';

// Definir el estado inicial
const initialState = {
  tableItems: [], // Inicialmente vacío
  loading: false,
  error: null,
};

// Definir el reducer
const actionsTicketReducer = (state = initialState, action) => {
  
    switch (action.type) {
        case types.SET_TICKETS:
          return {
            ...state,
            tableItems: action.payload,
          };
        case types.FETCH_ITEMS:
          return state; 
        case types.ADD_ITEM:
          return {
            ...state,
            tableItems: [...state.tableItems, action.payload],
          };
          case types.ADD_ANSWER_ITEM:
            return {
              ...state,
              tableItems: state.tableItems.map(item => {
                  if (item.id === action.payload.ticket_id) {
                      return {
                          ...item,
                          answers_number: (item.answers_number+1)
                      };
                  }
                  return item;
              })
          };
          case types.ADD_DOCUMENT_FLAG:
            return {
              ...state,
              tableItems: state.tableItems.map(item => {
                  if (item.id === action.payload) {
                      return {
                          ...item,
                          has_docs: true
                      };
                  }
                  return item;
              })
          };
        case types.SAVE_ITEM:
          return {
            ...state,
            tableItems: state.tableItems.map(item =>
              item.id === action.payload.id ? action.payload : item
            ),
          };
        case types.DELETE_ITEM:
          return {
            ...state,
            tableItems: state.tableItems.filter(item => item.id !== action.payload),
          };
        case types.FETCH_ITEM_SUCCESS:
          return {
            ...state,
            tableItems: action.payload, 
            loading: false,
            error: null,
          };
        case types.FETCH_ITEM_FAILURE:
          return {
            ...state,
            loading: false,
            error: action.payload, 
          };
        default:
          return state;
      }
    
    return state;
};

export default actionsTicketReducer;